import { oc } from '@orpc/contract'
import { z } from 'zod'

export const documentCommentSchema = z.object({
  id: z.string().min(1),
  documentId: z.string().min(1),
  threadId: z.string().min(1),
  parentId: z.string().nullable(),
  authorId: z.string().min(1),
  authorName: z.string(),
  content: z.string(),
  quotedText: z.string().nullable(),
  isResolved: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export const documentCommentThreadSchema = z.object({
  threadId: z.string().min(1),
  quotedText: z.string().nullable(),
  isResolved: z.boolean(),
  comments: z.array(documentCommentSchema),
})

export type DocumentComment = z.infer<typeof documentCommentSchema>
export type DocumentCommentThread = z.infer<typeof documentCommentThreadSchema>

// --- Procedure contracts ---

export const documentCommentsListContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      documentId: z.string().min(1),
    })
  )
  .output(
    z.object({
      items: z.array(documentCommentThreadSchema),
    })
  )

export const documentCommentsCreateContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      documentId: z.string().min(1),
      threadId: z.string().min(1),
      content: z.string().min(1),
      quotedText: z.string().optional(),
      parentId: z.string().optional(),
      mentionedUserIds: z.array(z.string()).optional(),
    })
  )
  .output(documentCommentSchema)

export const documentCommentsResolveContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      documentId: z.string().min(1),
      threadId: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))

export const documentCommentsReopenContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      documentId: z.string().min(1),
      threadId: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))

export const documentCommentsDeleteContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      documentId: z.string().min(1),
      commentId: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))
